import HomeSider from '@/components/Home/HomeSider.tsx';
import { useKayAuth } from '@/context/AuthContext.tsx';
import Loading from '@/components/Loading.tsx';
import React from 'react';
import { useLocation } from 'react-router-dom';
import HistoryPage from './History.tsx';
import HomeMainPage from './Home.tsx';
import SettingsPage from '@/components/Settings/Settings.js';
import {paths} from "@/constants/paths.js";

const Main = () => {
  const { user } = useKayAuth();
  const location = useLocation();

  const usePathSegment = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    return pathSegments[0] ?? null;
  };

  const path = usePathSegment();

  const getComponent = () => {
    switch (path) {
      case paths.SETTINGS:
        return <SettingsPage />;
      case paths.HISTORY:
        return <HistoryPage />;
      case paths.HOME:
      default:
        return <HomeMainPage />;
    }
  };

  if (!user) {
    return <Loading />;
  }

  return (
    <div className="flex h-screen">
      <HomeSider />

      <main className="flex-1 space-y-3 overflow-scroll bg-kay-slate">

        <div className='p-9 md:p-12'>
          {getComponent()}
        </div>
      </main>
    </div>
  );
};

export default Main;
